import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = ({ t }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: `${process.env.PUBLIC_URL}/images/herosection.jpg`,
      title: t.slides[0].title,
      subtitle: t.slides[0].subtitle
    },
    {
      image: `${process.env.PUBLIC_URL}/images/goree.jpg`,
      title: t.slides[1].title,
      subtitle: t.slides[1].subtitle
    },
    {
      image: `${process.env.PUBLIC_URL}/images/lacrose.jpg`,
      title: t.slides[2].title,
      subtitle: t.slides[2].subtitle
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const heroStyle = {
    backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${slides[currentSlide].image})`
  };

  return (
    <section id="home" className="hero" style={heroStyle}>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>{slides[currentSlide].title}</h1>
        <p>{slides[currentSlide].subtitle}</p>
        <div className="hero-buttons">
          <a href="#tours" className="btn-primary">{t.exploreTours}</a>
          <a href="#contact" className="btn-secondary">{t.contactUs}</a>
        </div>
      </div>

      {/* Slider Dots */}
      <div className="slider-dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          ></span>
        ))}
      </div>

      <div className="scroll-indicator">
        <i className="fas fa-chevron-down"></i>
      </div>
    </section>
  );
};

export default Hero;
